import { FaSquareFull } from "react-icons/fa";
import { AiFillCaretLeft } from "react-icons/ai"; 
import { BiSave } from "react-icons/bi"; 
import CxIcon from '../../cx/CxIcon';
import CxIconButtonNew from '../../cx/CxIconButtonNew';
import CxButton from '../../cx/CxButton';
import React from 'react';
import { useNav } from '../../hx/useNav';
import { useTranslation } from '../../hx/useTranslation';
import CxSnackbar from '../../cx/CxSnackbar';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import * as FxFetch from '../../fx/FxFetch';
import * as FxStr from '../../fx/FxStr';
import '../../../styles/main.css';
import GxForm from '../../gx/GxForm';
import CxChooser from '../../cx/CxChooser';


const MxSettCalendarGoogle = (props) => {
  const [{ trans }] = useTranslation();
  const [{ navBack }] = useNav();

  const r_snack_save = React.useRef(null);
  const r_snack_required = React.useRef(null);

  let r_form = React.useRef(null);

  const rf_itCalendarColForGoogle = React.useRef(null);
  const rf_itCalendarGrpForGoogle = React.useRef(null);


  React.useEffect(() => {
    formLoad();
    // eslint-disable-next-line
  }, []);
  
  const formLoad = async () => {
    let record = {};
    Promise.all([FxFetch.doJsonX('cal/sett', record)]).then((result) => {
      if (result[0]) {
        rf_itCalendarColForGoogle.current.setKeyAndVal('t_calendar_col', 'txTypeCalendarCol', 'itCalendarCol', result[0].itCalendarColForGoogle);
        rf_itCalendarGrpForGoogle.current.setKeyAndVal('t_calendar_grp', 'txTypeCalendarGrp', 'itCalendarGrp', result[0].itCalendarGrpForGoogle);
      }
    });

  }

  const formSaveCustom = async () => {
    if (rf_itCalendarColForGoogle.current.isEmpty()) {
      r_snack_required.current.setVal(trans('field.required') + ": " + rf_itCalendarColForGoogle.current.getLabel());
      r_snack_required.current.setOpen(true);
      return;
    }
    if (rf_itCalendarGrpForGoogle.current.isEmpty()) {
      r_snack_required.current.setVal(trans('field.required') + ": " + rf_itCalendarGrpForGoogle.current.getLabel());
      r_snack_required.current.setOpen(true);
      return;
    }

    let record = {};
    record['itCalendarColForGoogle'] = rf_itCalendarColForGoogle.current.getKey();
    record['itCalendarGrpForGoogle'] = rf_itCalendarGrpForGoogle.current.getKey();
    Promise.all([FxFetch.doJsonF("sett/cal/google/u", null, record)]).then((result) => {
      if (result[0]) {
        if (result[0].theValue === 'OK') {
          r_snack_save.current.setOpen(true);
        }
      }
    });

    r_snack_save.current.setOpen(true);
  }

  const doInstall = async () => {
    const objRes = await FxFetch.doJsonX('cal/auth-url', {});
    if (objRes && objRes.txUrl) {
      // Abre la URL de Google en una pestaña o ventana nueva
      window.open(objRes.txUrl, '_blank');
    }
  };

  return (
    <div>
      <GxForm
        moduleName={`${trans('field.calendars')} - Google`}
        xref={r_form}
        addToolbarButtons={
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <CxIconButtonNew icon={<CxIcon backIcon={<BiSave/>} frontIcon={<AiFillCaretLeft/>} />} classType="ibs_iconbutton_toolbar" onClick={() => formSaveCustom()} tooltip={trans('field.save_and_exit')} />
          </div>
        }
      >
        <CxChooser xref={rf_itCalendarColForGoogle} label={trans('field.destination_x', 'field.column')}
          dbfield="t_calendar_col.txTypeCalendarCol" dbfieldkey={`n_calendar.itCalendarCol`}
          table="t_calendar_col"
          col_id="itCalendarCol"
          col_tx="txTypeCalendarCol"
          extra_column_value_1={{
            id: "2", Header: trans('field.color'), accessor: row => {
              return <CxIconButtonNew icon={<FaSquareFull fontSize="20px" style={{ color: FxStr.rgb2hex(row["txRgb"]), border: '1px solid gray' }} />} />
            }, width: '20%', align: 'center'
          }}
          required
        />
        <CxChooser xref={rf_itCalendarGrpForGoogle} label={trans('field.destination_x', 'field.group')}
          dbfield="t_calendar_grp.txTypeCalendarGrp" dbfieldkey={`n_calendar.itCalendarGrp`}
          table="t_calendar_grp"
          col_id="itCalendarGrp"
          col_tx="txTypeCalendarGrp"
          extra_column_field_1="txRgb"
          extra_column_value_1={{
            id: "2", Header: trans('field.color'), accessor: row => {
              return <CxIconButtonNew icon={<FaSquareFull fontSize="20px" style={{ color: FxStr.rgb2hex(row["txRgb"]), border: '1px solid gray' }} />} />
            }, width: '20%', align: 'center'
          }}
          required
        />


        <div style={{ width: '100%', textAlign: 'left', display: 'flex', flexDirection: 'row', flexFlow: 'row wrap', gap: '5px' }}> {/* línea separada */}
          <CxButton label={trans('field.install')} onClick={doInstall} />
        </div>

      </GxForm>

      <CxSnackbar xref={r_snack_save} severity="success" value={trans('msg.saved')} onClose={() => navBack()} />
      <CxSnackbar xref={r_snack_required} severity="error" />

    </div>
  );

}

export default MxSettCalendarGoogle;
